module.exports = __webpack_public_path__ + "img/sustainability.ff697f6.webp";